"use strict";

exports.__esModule = true;
exports.default = void 0;

function joinPaths() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return paths.map(function (path, i, list) {
    return i === list.length - 1 ? path.replace(/\/$/, '').replace(/^\//, '') : path.replace(/[^/]$/, '$&/').replace(/^\//, '');
  }).join('');
}

var _default = joinPaths;
exports.default = _default;